import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import client, { apiError } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=authed
  const isCallback = typeof window !== "undefined" && window.location.hash?.includes("session_id=");

  const check = useCallback(async () => {
    const token = localStorage.getItem("jpi_token");
    if (!token) return setUser(false);
    try {
      const { data } = await client.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("jpi_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (isCallback) return;
    // Fallback de sécurité : si check() ne répond pas en 20s, on passe en guest
    const fallback = setTimeout(() => setUser((u) => u === null ? false : u), 20000);
    check().finally(() => clearTimeout(fallback));
  }, [check, isCallback]);

  const login = async (email, password) => {
    try {
      const { data } = await client.post("/auth/login", { email, password });
      localStorage.setItem("jpi_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e.response?.data?.detail) };
    }
  };

  const register = async (email, password, name, accessCode) => {
    try {
      const { data } = await client.post("/auth/register", { email, password, name, accessCode });
      localStorage.setItem("jpi_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e.response?.data?.detail) };
    }
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const finishGoogle = async (sessionId) => {
    const { data } = await client.post("/auth/google", { session_id: sessionId });
    localStorage.setItem("jpi_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("jpi_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, loginWithGoogle, finishGoogle, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}